export default __webpack_public_path__ + "static/media/icons8-application-window.99ebaa99.svg";